<template>
    <div class="consulAddDialog">
        <div ref="meetingfrom">
            <div class="basicTitle">天长市农村社区协商办理结果评议单</div>
            <div class="basicSubTitle">社区：{{ communityName }}</div>
            <table class="basicTable">
                <tr class="basicTableLeft">
                    <th>议题内容</th>
                    <th>评议内容</th>
                    <th>评议形式</th>
                    <th>评议结束</th>
                    <th>发布日期</th>
                    <th>评议结果运用</th>
                    <th>备注</th>
                </tr>
                <tr class="basicTableRight">
                    <td class="basicTableRightTd">{{ content }}</td>
                    <td class="basicTableRightTd">
                        <textarea
                            maxlength="30"
                            name="commentContent"
                            style="width: 99%; height: 99%; border: none"
                            v-model="pingyiform.commentContent"
                        >
                        </textarea>
                        <!-- <input type="text" style="width:99%;height:99%;border:none;" v-model="pingyiform.commentContent"> -->
                    </td>
                    <td class="basicTableRightTd">
                        <table>
                            <tr>
                                <th>书面</th>
                                <th>微信/QQ</th>
                                <th>电话</th>
                                <th>会议</th>
                                <th>其他</th>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        name="commentType1"
                                        v-model="commentType1"
                                        type="checkbox"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="commentType2"
                                        v-model="commentType2"
                                        type="checkbox"
                                        value="1"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="commentType3"
                                        v-model="commentType3"
                                        type="checkbox"
                                        value="2"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="commentType4"
                                        v-model="commentType4"
                                        type="checkbox"
                                        value="3"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="commentType5"
                                        v-model="commentType5"
                                        type="checkbox"
                                        value="4"
                                    />
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td class="basicTableRightTd">
                        <table>
                            <tr>
                                <th>同意</th>
                                <th>不同意</th>
                                <th>同意</th>
                                <th>不同意</th>
                                <th>同意</th>
                                <th>不同意</th>
                                <th>同意</th>
                                <th>不同意</th>
                                <th>同意</th>
                                <th>不同意</th>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        name="smCommentResult"
                                        v-model="pingyiform.smCommentResult"
                                        type="radio"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="smCommentResult"
                                        v-model="pingyiform.smCommentResult"
                                        type="radio"
                                        value="1"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="wechatCommentResult"
                                        v-model="pingyiform.wechatCommentResult"
                                        type="radio"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="wechatCommentResult"
                                        v-model="pingyiform.wechatCommentResult"
                                        type="radio"
                                        value="1"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="phoneCommentResult"
                                        v-model="pingyiform.phoneCommentResult"
                                        type="radio"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="phoneCommentResult"
                                        v-model="pingyiform.phoneCommentResult"
                                        type="radio"
                                        value="1"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="meetingCommentResult"
                                        v-model="
                                            pingyiform.meetingCommentResult
                                        "
                                        type="radio"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="meetingCommentResult"
                                        v-model="
                                            pingyiform.meetingCommentResult
                                        "
                                        type="radio"
                                        value="1"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="qtCommentResult"
                                        v-model="pingyiform.qtCommentResult"
                                        type="radio"
                                        value="0"
                                    />
                                </td>
                                <td>
                                    <input
                                        name="qtCommentResult"
                                        v-model="pingyiform.qtCommentResult"
                                        type="radio"
                                        value="1"
                                    />
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td class="basicTableRightTdFive">
                        <table>
                            <tr>
                                <th>
                                    <el-date-picker
                                        v-model="pingyiform.publishTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                    >
                                    </el-date-picker>
                                </th>
                                <th>汇总日期</th>
                                <th>
                                    <el-date-picker
                                        v-model="pingyiform.summaryTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                    >
                                    </el-date-picker>
                                </th>
                            </tr>
                        </table>
                    </td>
                    <td class="basicTableRightTdSix">
                        <table>
                            <tr>
                                <th>
                                    <div class="eleinput">
                                        <textarea
                                            maxlength="50"
                                            name="commentResult"
                                            v-model="pingyiform.commentResult"
                                        >
                                        </textarea>
                                        <!-- <input type="textarea" name="commentResult" maxlength="100" v-model="pingyiform.commentResult"> -->
                                    </div>
                                    <!-- <el-input class="eleinput" type="textarea" name="commentResult" placeholder="请输入内容" v-model="pingyiform.commentResult"></el-input> -->
                                </th>
                                <th>评议比例分析</th>
                                <th>
                                    <div class="eleinput">
                                        <textarea
                                            maxlength="80"
                                            name="commentProportion"
                                            v-model="
                                                pingyiform.commentProportion
                                            "
                                        >
                                        </textarea>
                                        <!-- <input class="eleinput" type="text" name="commentProportion"  maxlength="100" v-model="pingyiform.commentProportion"> -->
                                    </div>
                                    <!-- <el-input class="eleinput" type="textarea" name="commentProportion" placeholder="请输入内容" v-model="pingyiform.commentProportion"></el-input> -->
                                </th>
                            </tr>
                        </table>
                    </td>
                    <td class="basicTableRightTd">
                        <textarea
                            maxlength="30"
                            name="remarks"
                            style="width: 99%; height: 99%; border: none"
                            v-model="pingyiform.remarks"
                        ></textarea>
                        <!-- <input type="text" v-model="pingyiform.remarks" style="width:99%;height:99%;border:none;"> -->
                    </td>
                </tr>
            </table>
            <div class="pingYiRen">
                评议人或汇总人：<input
                    type="text"
                    v-model="pingyiform.commentPerson"
                    style="width: 99%; height: 50px; border: none"
                    placeholder="请输入..."
                />
            </div>
            <div class="pingYiRen">
                是否列为协商案例：
                <el-radio-group v-model="isAnLi">
                    <el-radio label="0">是</el-radio>
                    <el-radio label="1">否</el-radio>
                </el-radio-group>
            </div>
            <div style="margin-top: 20px">
                上传图片
                <el-upload
                    style="margin: -10px 0 0 80px"
                    :limit="1"
                    :class="{ hide: hideUpload }"
                    :action="url"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview2"
                    :on-success="imgok"
                    :file-list="fileListimg"
                    :on-remove="handleRemove2"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                    :modal-append-to-body="false"
                    :visible.sync="dialogVisible1"
                >
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </div>
        </div>
        <div class="boontbtn">
            <!-- <el-button type="primary" @click="dayin">打印</el-button> -->
            <el-button type="primary" @click="onSave">确认</el-button>
            <el-button type="info" @click="quxiao">取消</el-button>
        </div>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import baseURL from "@/api/baseURL"
export default {
    props: ["ytid"],
    data() {
        return {
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            fileListimg: [],
            dialogImageUrl: false,
            dialogVisible1: false,
            isAnLi: "",
            id: this.ytid,
            content: "",
            communityName: "",
            value1: "",
            formPhoto: "",
            value2: "",
            hideUpload: false,
            commentType1: "",
            commentType2: "",
            commentType3: "",
            commentType4: "",
            commentType5: "",
            pingyiform: {
                commentType: "",
                smCommentResult: "",
                wechatCommentResult: "",
                qqCommentResult: "",
                meetingCommentResult: "",
                qtCommentResult: "",
            },
            commentTypeList: [],
        }
    },
    methods: {
        getFindConsultById() {
            console.log(this.ytid)
            post("/admin/consult/info/findConsultById", {
                id: this.ytid,
            }).then((res) => {
                console.log(res)
                this.content = res.content.content
                // console.log(res.content.communityId)
                if (res.content.communityId == "2") {
                    this.communityName = "浔河社区"
                } else if (res.content.communityId == "20") {
                    this.communityName = "石街社区"
                }
                this.hideUpload = false
            })
        },
        gettjAnlI() {
            //循环拼接
            var str = ""
            if (Array.isArray(this.fileListimg)) {
                this.fileListimg.map((item, index) => {
                    str += item + "#"
                })
            }
            console.log(str)
            this.formPhoto = str
            let paroms = {
                id: this.ytid,
                cases: this.isAnLi,
                casesPhoto: this.formPhoto,
            }
            console.log(paroms)
            post("/admin/consult/info/updateConsultCases", paroms).then(
                (res) => {
                    console.log(res)
                }
            )
        },
        // 上传图片
        handlePictureCardPreview2(file) {
            console.log(file)
            this.hideUpload = false
            if (file) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            this.dialogImageUrl = file.url
            this.dialogVisible1 = true
        },
        imgok: function (data, data1, data2) {
            this.hideUpload = false
            if (data) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            console.log(data)
            if (data.code == 200) {
                this.fileListimg.push(data.content)
            }
        },
        handleRemove2(file) {
            this.fileListimg.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.fileListimg.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.formPhoto.splice(index, 1)
                    }
                }
            })
            console.log(this.fileListimg)
            this.hideUpload = false
            if (this.fileListimg.length > 0) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
        },
        getData() {
            this.pingyiform = {}
            this.commentType1 = false
            this.commentType2 = false
            this.commentType3 = false
            this.commentType4 = false
            this.commentType5 = false
            this.commentTypeList = []
            this.isAnLi = ""
            this.fileListimg = []
        },
        onSave() {
            this.gettjAnlI()
            if (this.commentType1 == true) {
                this.commentTypeList.push(0)
            }
            if (this.commentType2 == true) {
                this.commentTypeList.push(1)
            }
            if (this.commentType3 == true) {
                this.commentTypeList.push(2)
            }
            if (this.commentType4 == true) {
                this.commentTypeList.push(3)
            }
            if (this.commentType5 == true) {
                this.commentTypeList.push(4)
            }
            this.pingyiform.commentType = ""
            this.pingyiform.commentType = this.commentTypeList + ""
            // console.log(this.pingyiform.commentType)
            post("/admin/consultComment/info/insertConsultComment", {
                ...this.pingyiform,
                consultId: this.ytid,
                smCommentResult: this.pingyiform.smCommentResult,
                wechatCommentResult: this.pingyiform.wechatCommentResult,
                qqCommentResult: this.pingyiform.qqCommentResult,
                meetingCommentResult: this.pingyiform.meetingCommentResult,
                qtCommentResult: this.pingyiform.qtCommentResult,
            })
                .then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                        })
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        })
                    }
                    this.$emit("close")
                })
                .catch(() => {})
        },
        quxiao() {
            this.$emit("close")
        },
        dayin() {
            this.$print(this.$refs.meetingfrom)
        },
    },
    mounted() {
        this.getFindConsultById()
    },
}
</script>

<style lang="less" scoped>
.consulAddDialog {
    margin: 40px;
    .el-form-item {
        margin-bottom: 10px;
        .el-form-item__error {
            top: 85%;
        }
    }
}
.basicTitle {
    font-size: 25px;
    text-align: center;
}
.basicSubTitle {
    font-size: 22px;
    margin-bottom: 20px;
}
.queRenBtn {
    margin: 60px 0;
}
.basicTable {
    // display: flex;
    // flex-direction: row;
    border-right: 1px solid #804040;
    border-bottom: 1px solid #804040;
    border-collapse: collapse;
    width: 100%;
}
// .basicTable tr:nth-child(1) {
//   width: 15%;
// }
// .basicTable tr:nth-child(2) {
//   width: 85%;
// }
.basicTable tr th {
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #804040;
    border-top: 1px solid #804040;
}
.basicTable tr th:nth-child(6) {
    height: 400px;
}
.basicTable tr td:nth-child(6) {
    height: 403px;
}
.basicTable tr td {
    height: 63px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #804040;
    border-top: 1px solid #804040;
}
.basicTableLeft {
    display: inline-block;
    width: 87px;
    // background: red;
}
.basicTableRight {
    display: inline-block;
    // background: green;
    width: calc(100% - 87px);
}
.basicTableRightTd {
    display: flex;
}
.basicTableRightTd table {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
}
.basicTableRightTd {
    display: flex;
    flex-direction: row;
    height: 30px;
    flex: 1;
    box-sizing: border-box;
}
.basicTableRightTd tr {
    display: flex;
    margin-left: -1px;
}
.basicTableRightTd th {
    height: 28px !important;
    flex: 1;
    border-top: none !important;
}
.basicTableRightTd td {
    height: 28px !important;
    flex: 1;
    border: none;
}
.basicTableRightTd tr th:first-child {
    border-left: none !important;
}
.basicTableRightTd tr td:first-child {
    border-left: none !important;
}
.basicTableRightTdFive {
    display: flex;
}
.basicTableRightTdFive table {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
}
.basicTableRightTdFive {
    display: flex;
    flex-direction: row;
    height: 30px;
    flex: 1;
    box-sizing: border-box;
}
.basicTableRightTdFive tr {
    display: flex;
    margin-left: -1px;
}
.basicTableRightTdFive th {
    height: 61px !important;
    flex: 1;
    border-top: none !important;
}
.basicTableRightTdFive th:nth-child(2) {
    width: 61px !important;
}
.basicTableRightTdFive tr th:first-child {
    border-left: none !important;
}
.basicTableRightTdFive tr td:first-child {
    border-left: none !important;
}
.basicTableRightTdSix {
    display: flex;
}
.basicTableRightTdSix table {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
}
.basicTableRightTdSix {
    display: flex;
    flex-direction: row;
    height: 30px;
    flex: 1;
    box-sizing: border-box;
}
.basicTableRightTdSix tr {
    display: flex;
    margin-left: -1px;
}
.basicTableRightTdSix th {
    height: 401px !important;
    flex: 1;
    border-top: none !important;
}
.basicTableRightTdSix th:nth-child(2) {
    width: 61px !important;
}
.basicTableRightTdSix tr th:first-child {
    border-left: none !important;
}
.basicTableRightTdSix tr td:first-child {
    border-left: none !important;
}
.pingYiRen {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 15px;
}
.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
</style>
<style lang="less">
.consulAddDialog .eleinput {
    width: 200px;
    height: 90%;
    margin: 0 15px;
    textarea {
        display: inline-block;
        border: none;
        width: 100%;
        height: 350px;
        font-size: 16px;
        line-height: 30px;
        resize: none;
        background-color: #fff;
    }
}
.hide {
    /deep/.el-upload--picture-card {
        display: none;
    }
}
</style>